import React, {useState, useEffect} from 'react';
import $ from 'jquery';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Dialog, {DialogActions, DialogContent, DialogContentText, DialogTitle,} from 'material-ui/Dialog';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Avatar from 'material-ui/Avatar';
import Chip from 'material-ui/Chip';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import AddIcon from 'material-ui-icons/Add';
import {NotificationManager} from 'react-notifications';
import {urlPrefix, get, post, postForm} from 'engine/dataServices';
import jMoment from 'moment-jalaali';
import ContainerHeader from 'components/ContainerHeader/index';
import InfoCard from 'components/InfoCard';
import ApallShareImage from 'assets/Images/SwiftImageIcons/Colored/1x/Shakinghands.png';
import ToDayCountImage from 'assets/Images/SwiftImageIcons/Colored/1x/Mobilepay.png';
import TotalCountImage from 'assets/Images/SwiftImageIcons/Colored/1x/Mastercard.png';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/Menu/MenuItem';
import {Link, Element, Events, animateScroll as scroll, scrollSpy, scroller} from 'react-scroll'
import {useDropzone} from 'react-dropzone';
import {Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText} from 'reactstrap';
import * as userManage from "../../../../engine/userManagements";
import Loading from 'app/loading';
import Validator from 'components/Validator';
import DataTable from 'components/customized/tables/datatable';

import {
    AlphaPicker,
    BlockPicker,
    ChromePicker,
    CirclePicker,
    CompactPicker,
    GithubPicker,
    HuePicker,
    MaterialPicker,
    PhotoshopPicker,
    SketchPicker,
    SliderPicker,
    SwatchesPicker,
    TwitterPicker,
} from 'react-color';
import imageCompression from 'browser-image-compression';

const headTitles = {
    borderBottom: 1,
    borderColor: 'gray',
    borderBottomStyle: 'solid',
    paddingBottom: 5,
    marginTop: 30,
    marginBottom: 20
}


const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};


const propertiesHeadTable = [
    {id: 'id', numeric: false, disablePadding: true, label: 'شناسه'},
    {id: 'name', numeric: false, disablePadding: true, label: 'عنوان'},
    {id: 'description', numeric: false, disablePadding: true, label: 'توضیحات'},
    {id: 'createDate', numeric: true, disablePadding: false, label: 'تاریخ ایجاد'},
    {id: 'modifiedDate', numeric: true, disablePadding: false, label: 'تاریخ آخرین ویرایش'}
];

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};

const imageThumb = {
    display: 'flex',
    width: 130,
    height: 130,
    borderRadius: 2,
    border: '1px solid #eaeaea',
    padding: 4,
    boxSizing: 'border-box'
};

const compressOptions = {
    maxSizeMB: 0.3,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 1920,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10,       // optional, max number of iteration to compress the image (default: 10)
    //onProgress: Function,       // optional, a function takes one progress argument (percentage from 0 to 100)
}


function Dropzone(props) {
    const [files, setFiles] = useState([]);
    const {getRootProps, getInputProps} = useDropzone({
        accept: ['image/jpg', 'image/jpeg'],
        /*minSize : 0,
        maxSize: 20000,*/
        onDrop: items => {
            const maxUploadSize = 18000000;

            if (items.length > 1) {
                NotificationManager.error('تنها می توان یک تصویر برای دسته بندی بارگذاری نمود.');
            }

            let acceptedFiles = [];
            let previews = [];

            const item = items[0];
            if (item.size <= maxUploadSize) {
                previews.push(item);
                imageCompression(item, compressOptions).then(x => this.setState({uploadFiles: [x]}));
            } else
                NotificationManager.error(`حداکثر مجاز برای حجم هر تصویر
                    ${maxUploadSize / 1000} 
                     کیلوبایت می باشد. حجم تصویر با نام
                     ${item.name}
                     بیش از مقدار مورد قبول می باشد.`
                    , 'خطای کاربری');

            setFiles(previews.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));

       /*     if (acceptedFiles.length > 0) {
                this.setState({uploadFiles: acceptedFiles});
            }*/
        },
        onDropRejected: () => NotificationManager.error('فرمت فایل قابل قبول تنها از نوع Jpg می باشد.', 'خطا')
    });

    const thumbs = files.map(file => {
        return (
            <div style={thumb} key={file.name}>
                <div style={thumbInner}>
                    <img
                        src={file.preview}
                        style={img}
                    />
                </div>
            </div>
        );
    });

    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);

    return (
        <section style={{display: 'flex', flexDirection: 'column', marginRight: 50, marginLeft: 50}}>
            <div {...getRootProps({className: 'dropzone'})} style={{
                flex: 1,
                flexDirection: 'column',
                alignItems: 'center',
                padding: 20,
                backgroundColor: '#fafafa',
                color: '#bdbdbd',
                borderStyle: 'dashed',
                borderRadius: 2,
                borderColor: '#eeeeee',
                borderWidth: 2,
                justifyContent: 'center',
                textAlign: 'center'
            }}>
                <input {...getInputProps()} />
                <p>جهت بارگزاری تصویر دسته بندی، تصویر مورد نظر را به اینجا Drag & Drop نموده و یا در این ناحیه کلیک
                    نمایید.</p>
                <aside style={thumbsContainer}>
                    {thumbs}
                </aside>
            </div>
        </section>
    );
}

const columnData = [
    //{id: 'Id', numeric: false, visible: false, disablePadding: true, label: 'شناسه'},
    {id: 'Color', numeric: false, disablePadding: true, label: 'رنگ'},
    {id: 'Image', numeric: false, disablePadding: true, label: 'تصویر'},
    {id: 'Name', numeric: false, disablePadding: true, label: 'نام'},
    {id: 'CreateDate', numeric: false, disablePadding: true, label: 'تاریخ ایجاد'},
    {id: 'ModifiedDate', numeric: false, disablePadding: true, label: 'تاریخ آخرین ویرایش'}
];


class DataTableHead extends React.Component {

    static propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        //onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const {//onSelectAllClick,
            order, orderBy, rowCount
        } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                                className='text-center'
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}


let ImageThumbs = props => {
    let parent = props.props;
    let {image} = parent.state;

    return (
        <div style={{marginBottom: 30, marginTop: 20}}>
            <div style={{display: 'inline-flex', flexDirection: 'column', marginRight: 15}}>
                <div style={imageThumb}>
                    <div style={thumbInner}>
                        <img
                            src={urlPrefix + image}
                            style={img}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)   // General scroll to element function


class Categories extends React.Component {


    constructor(props, context) {
        super(props, context);
        this.myRef = React.createRef();
        this.editPropertiesContainer = React.createRef();

        this.state = {
            id: '',
            name: '',
            price: '',
            stock: '',
            category: 0,
            uploadFiles: [],
            image: '',
            properties: [],
            tmpProperties: [],
            description: '',
            categories: [],
            txtFunctionType: '',
            showEditContainer: false,
            order: 'asc',
            orderBy: 'calories',
            selected: 0,
            data: [],
            page: 0,
            rowsPerPage: 5,
            loading: true,
            showEditPropertiesContainer: false,
            propertiesFunctionType: '',
            txtPropertiesFunctionType: '',
            propertyId: 0,
            propertyName: '',
            propertyDesc: '',
            showPermenantDialog: false,
            permenantDialogType: '',
            permenantDialogContent: '',
            dialogSelectedId: 0,
        };

        this.validator = Validator();

        Dropzone = Dropzone.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    handleLoading = (status) => {
        this.setState({loading: status})
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({data, order, orderBy});
    };
    handleKeyDown = (event, id) => {
        if (keycode(event) === 'space') {
            this.handleClick(event, id);
        }
    };
    handleClick = (event, id) => {
        this.setState({selected: id});
    };
    handleChangePage = (event, page) => {
        this.setState({page});
    };
    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    isSelected = id => this.state.selected === id;

    async loadData() {
        this.setState({showEditContainer: false, functionType: ''});

        let response = await get('Category/Get');
        if (response.status === 200) {
            var _data = await response.json();
            this.setState({
                data: _data
            })
        }
        this.handleLoading(false);
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleChange_dynamicFileds = id => event => {
        let obj = this.state.properties;
        let index = obj.findIndex(x => x.Id == id)
        obj[index].Value = event.target.value;
        this.setState({
            properties: obj
        });
    };

    loadProperties = async (categoryId) => {
        let responseResult = await get('Property/GetProperties?categoryId=' + categoryId);
        const properties = await responseResult.json();
        const _properties = properties.map(item => {
            return {
                id: item.Id,
                name: item.Name,
                description: item.Description,
                createdDate: jMoment(item.CreatedDate).format('HH:mm - jYYYY/jMM/jDD'),
                modifiedDate: (item.ModifiedDate) ? jMoment(item.ModifiedDate).format('HH:mm - jYYYY/jMM/jDD') : 'ّبدون ویرایش'
            }
        })
        this.setState({properties: _properties});
    };

    loadCategoryDetailsToEdit = async (id) => {
        const res = await get(`Category/GetDetailById?id=${id}`);
        const data = await res.json();
        this.setState({name: data.Name, description: data.Description, image: data.Image, color: data.Color});
    }

    loadPropertiesToEdit = async (id) => {
        let responseResult = await get('Property/GetProperty?id=' + id);
        const property = await responseResult.json();
        this.setState({propertyId: property.Id, propertyName: property.Name, propertyDesc: property.Description});
    }

    AddOrEditBtn = async (functionType, item) => {
        if (functionType) {
            this.handleLoading(true);
            this.cleanForm();
            this.setState({showEditContainer: true, functionType: functionType});

            switch (functionType) {
                case 'Add':
                    this.setState({txtFunctionType: 'افزودن دسته بندی'});
                    break;
                case 'Edit':
                    this.setState({txtFunctionType: 'ویرایش دسته بندی', category: item.Id});
                    await this.loadCategoryDetailsToEdit(item.Id);
                    await this.loadProperties(item.Id);
                    break;
            }
            this.handleLoading(false);
            this.scroll(this.myRef);
        }


    }

    AddOrEditPropertiesBtn = async (functionType, item) => {
        if (functionType) {
            this.handleLoading(true);
            this.cleanProperiesForm();
            this.setState({showEditPropertiesContainer: true, propertiesFunctionType: functionType});

            switch (functionType) {
                case 'Add':
                    this.setState({txtPropertiesFunctionType: 'افزودن آیتم پویا'});
                    break;
                case 'Edit':
                    this.setState({txtPropertiesFunctionType: 'ویرایش آیتم پویا'});
                    let selectedId = event.target.getAttribute('data-id');
                    if (!selectedId) selectedId = event.target.offsetParent.getAttribute('data-id');
                    let rowSelected = event.target.getAttribute('data-extra');
                    if (!rowSelected) rowSelected = event.target.offsetParent.getAttribute('data-extra');
                    if (selectedId < 0) {
                        let _data = JSON.parse(rowSelected);
                        this.setState({
                            propertyId: selectedId,
                            propertyName: _data.name,
                            propertyDesc: _data.description
                        });
                        break;
                    }
                    await this.loadPropertiesToEdit(selectedId);
                    break;
            }
            this.handleLoading(false);
            this.scroll(this.editPropertiesContainer);
        }


    }

    scroll(ref) {
        ref.current.scrollIntoView({behavior: 'smooth'})
    }

    submitBtn = async () => {
        try {
            let validFields = true;
            let fields = ['عنوان دسته بندی', 'رنگ', 'توضیحات'];

            fields.map((field) => {
                if (!this.validator.fieldValid(field)) {
                    validFields = false;
                    return;
                }
            });

            if (validFields) {
                this.handleLoading(true);
                switch (this.state.functionType) {
                    case 'Add':
                        if (this.state.uploadFiles.length === 0) {
                            NotificationManager.error('بارگزاری تصویر برای دسته بندی الزامی می باشد.', 'خطا');
                            break;
                        }
                        await this.addCategory();
                        break;
                    case 'Edit':
                        await this.updateCategory();
                        break;
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        } finally {
            this.handleLoading(false)
        }

    }

    submitPropertiesBtn = async () => {
        try {
            let validFields = true;
            let fields = ['توضیحات آیتم', 'عنوان آیتم']
            fields.map((field) => {
                if (!this.validator.fieldValid(field)) {
                    validFields = false;
                    return;
                }
            });

            if (validFields) {
                this.handleLoading(true);
                switch (this.state.propertiesFunctionType) {
                    case 'Add':
                        await this.addProperty();
                        break;
                    case 'Edit':
                        await this.updateProperty();
                        break;
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        } finally {
            this.handleLoading(false)
        }

    }

    addCategory = async () => {
        let {name, color, properties, uploadFiles, description} = this.state;
        properties = properties.filter(x => x.id < 0);

        if (properties.length <= 3) {
            NotificationManager.error(`می بایست حداقل 3 آیتم پویا برای دسته بندی در نظر گرفته شود.`, 'خطا');
            return;
        }

        properties = properties.map(item => {
            return {
                name: item.name,
                description: item.description
            }
        });

        let form = new FormData();
        form.append('Images', uploadFiles[0]);
        form.append('Name', name);
        form.append('Color', color);
        form.append('Description', description);
        form.append('Properties', JSON.stringify(properties));

        var response = await postForm('Category/Create', form);
        switch (response.status) {
            case 200:
                NotificationManager.success(`دسته بندی ${name} با موفقیت در تولیتون ثبت شد.`, 'عملیات موفق');
                this.loadData();
                return;
        }
        NotificationManager.error(`خطا در ثبت دسته بندی`, 'خطا');
    }

    updateCategory = async () => {
        let editFormData = new FormData();
        let {name, color, category, properties, uploadFiles, description} = this.state;
        for (var index = 0; index < uploadFiles.length; index++) {
            var element = uploadFiles[index];
            editFormData.append('Images', element);
        }
        editFormData.append('Id', category);
        editFormData.append('name', name);
        editFormData.append('color', color);
        editFormData.append('Description', description);

        properties = properties.filter(x => x.id < 0);
        properties = properties.map(item => {
            return {
                name: item.name,
                description: item.description
            }
        });

        editFormData.append('Properties', JSON.stringify(properties));

        var response = await postForm('Category/Update', editFormData);
        switch (response.status) {
            case 200:
                NotificationManager.success(`دسته بندی ${name} با موفقیت در تولیتون ویرایش شد.`, 'عملیات موفق');
                this.loadData();
                return;
        }
        NotificationManager.error(`خطا در ثبت دسته بندی`, 'خطا');
    }

    deleteCategory = async (id) => {
        this.setState({
            permenantDialogContent: 'آیا از حذف این دسته بندی اطمینان دارید؟',
            permenantDialogType: 'Category',
            dialogSelectedId: id,
            showPermenantDialog: true,
        });
    };

    addProperty = async () => {
        let {properties, propertyId, propertyName, propertyDesc} = this.state;
        if (propertyId) {
            let index = properties.findIndex(x => x.id == propertyId);
            properties[index].name = propertyName;
            properties[index].description = propertyDesc;
        } else {
            let minId = 0;
            let tmp = properties.filter(x => x.id < 0);
            if (tmp) {
                tmp.map(item => {
                    if (item.id < minId)
                        minId = item.id;
                });
            }
            let data = {
                id: minId - 1,
                name: propertyName,
                description: propertyDesc,
                createdDate: 'آیتم هنوز ثبت نشده است.',
                modifiedDate: 'آیتم هنوز ثبت نشده است.'
            };
            properties.push(data);
        }

        this.setState({properties: properties, showEditPropertiesContainer: false});


        /*var response = await post('Property/Create', data);
        switch (response.status) {
            case 200:
                NotificationManager.success(`آیتم ${name} با موفقیت در تولیتون ثبت شد.`, 'عملیات موفق');
                this.loadProperties(category);
                return;
        }
        NotificationManager.error(`خطا در ثبت آیتم`, 'خطا');*/
    }

    updateProperty = async () => {
        try {
            const {propertyId, propertyName, propertyDesc, properties} = this.state;
            if (propertyId > 0) {
                const data = {
                    Id: propertyId,
                    Name: propertyName,
                    Description: propertyDesc
                }
                let res = await post('Property/Update', data);

                if (res.status == 200) {
                    NotificationManager.success(' عملیات ویرایش آیتم با موفقیت انجام شد.', 'عملیات موفق');
                    let index = properties.findIndex(x => x.id == propertyId);
                    properties[index].name = propertyName;
                    properties[index].description = propertyDesc;
                    this.setState({properties: properties});
                }
            }
            if (propertyId < 0) {
                let index = properties.findIndex(x => x.id == propertyId);
                properties[index].name = propertyName;
                properties[index].description = propertyDesc;

            }

            this.closePropertiesEditContainer();
        } catch (e) {

        } finally {
        }
    };

    deleteProperty = async () => {
        let selectedId = event.target.getAttribute('data-id');
        if (!selectedId) selectedId = event.target.offsetParent.getAttribute('data-id');

        if (selectedId < 0) {
            let _properties = this.state.properties;
            _properties = _properties.filter(x => x.id != selectedId);
            this.setState({properties: _properties});
        }
        if (selectedId > 0) {
            var res = await post(`Property/Delete?id=${selectedId}&isPermenant=0`);
            if (res.status == 200) {
                const isDeleted = await res.json();
                if (isDeleted) {
                    let _properties = this.state.properties;
                    _properties = _properties.filter(x => x.id != selectedId);
                    this.setState({properties: _properties});
                    NotificationManager.success(' عملیات حذف محصول با موفقیت انجام شد.', 'عملیات موفق');
                } else {
                    this.setState({
                        permenantDialogContent: 'از این آیتم پویا به محصولات اختصاص داده شده و در صورت حذف اطلاعات آن از محصول نیز حذف خواهد شد. از حذف آن اطمینان دارید؟',
                        permenantDialogType: 'Property',
                        dialogSelectedId: selectedId,
                        showPermenantDialog: true,
                    });
                }
            }
        }
    }

    closeEditContainer = () => {
        this.setState({showEditContainer: false});
    }

    closePropertiesEditContainer = () => {
        this.setState({showEditPropertiesContainer: false});
    }

    cleanForm = () => {
        this.setState({
            id: '',
            name: '',
            price: '',
            stock: '',
            category: 0,
            uploadFiles: [],
            image: '',
            properties: [],
            description: '',
            tmpProperties: []
        });
    }

    cleanProperiesForm = () => {
        this.setState({
            propertyId: 0,
            propertyName: '',
            propertyDesc: ''
        });
    }

    handleDeleteBtn = async () => {
        const {permenantDialogType, dialogSelectedId} = this.state;

        this.handleLoading(true);
        switch (permenantDialogType) {
            case 'Category':
                let response = await post(`Category/Delete?id=${dialogSelectedId}`);
                if (response.status == 200) {
                    NotificationManager.success(' عملیات حذف دسته بندی با موفقیت انجام شد.', 'عملیات موفق');
                    this.loadData();
                }
                break;
            case 'Property':
                const propResponse = await post(`Property/Delete?id=${dialogSelectedId}&isPermenant=1`);
                if (propResponse.status == 200) {
                    let _properties = this.state.properties;
                    _properties = _properties.filter(x => x.id != dialogSelectedId);
                    this.setState({properties: _properties, showPermenantDialog: false});
                    NotificationManager.success(' عملیات حذف آیتم پویا با موفقیت انجام شد.', 'عملیات موفق');
                }
                break;
        }
        this.setState({showPermenantDialog: false});

        this.handleLoading(false);
    }

    handleOpenDeleteModal = async () => {
        this.setState({showPermenantDialog: true});
    }

    handleCloseDeleteModal = async () => {
        this.setState({showPermenantDialog: false});
    }


    render() {
        const {data, order, orderBy, selected, rowsPerPage, page} = this.state;
        const {properties, category, categories, image, price, stock} = this.state;


        return (
            <div>
                {this.state.loading && <Loading/>}

                <ContainerHeader match={this.props.match} title="مدیریت دسته بندی ها"/>

                <Paper>
                    {/*<DataTableToolbar/>*/}

                    <div style={{paddingTop: 15}}>
                        <Button variant="raised" className="jr-btn bg-success jr-btn-sm text-white"
                                style={{marginRight: 10}} onClick={this.AddOrEditBtn.bind(this, "Add")}>
                            <i className="zmdi zmdi-plus zmdi-hc-fw"/>
                            <span>افزودن</span>
                        </Button>
                    </div>

                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <Table className="">
                                <DataTableHead
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={data.length}
                                />
                                <TableBody>
                                    {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                        const isSelected = this.isSelected(n.Id);
                                        return (
                                            <TableRow
                                                hover
                                                onClick={event => this.handleClick(event, n.Id)}
                                                onKeyDown={event => this.handleKeyDown(event, n.Id)}
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.Id}
                                                selected={isSelected}
                                            >
                                                <TableCell padding="none"
                                                           className="text-center">
                                                    <div style={{
                                                        backgroundColor: `${n.Color}`,
                                                        height: 22,
                                                        width: 22,
                                                        borderRadius: 50,
                                                        margin: 'auto'
                                                    }}></div>
                                                </TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.Image.length > 0 && (
                                                    <img src={urlPrefix + n.Image}
                                                         style={{
                                                             height: 70,
                                                             borderRadius: 10,
                                                             marginTop: 5,
                                                             marginBottom: 5
                                                         }}/>
                                                )}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.Name}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">{jMoment(n.CreatedDate).format('HH:mm - jYYYY/jMM/jDD')}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">{(n.ModifiedDate) ? jMoment(n.ModifiedDate).format('HH:mm - jYYYY/jMM/jDD') : 'در انتظار تایید...'}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">
                                                    <Button variant="raised"
                                                            className="jr-btn bg-cyan jr-btn-sm text-white"
                                                            style={{marginRight: 10}}
                                                            onClick={this.AddOrEditBtn.bind(this, "Edit", n)}>
                                                        <i className="zmdi zmdi-edit zmdi-hc-fw"/>
                                                        <span>ویرایش</span>
                                                    </Button>
                                                    <Button variant="raised"
                                                            onClick={this.deleteCategory.bind(this, n.Id)}
                                                            className="jr-btn bg-red jr-btn-sm text-white"
                                                            style={{marginRight: 10}}>
                                                        <i className="zmdi zmdi-delete zmdi-hc-fw"/>
                                                        <span>حذف</span>
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={data.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
                </Paper>

                <div id="editContainer" ref={this.myRef} style={{paddingTop: 5}}>
                    {this.state.showEditContainer && (
                        <section>
                            <Card className={`shadow border-0`} style={{marginTop: 25}}>
                                <CardHeader className="bg-primary text-white">{this.state.txtFunctionType}</CardHeader>
                                <CardBody>
                                    <form className="row" noValidate autoComplete="off">
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <TextField
                                                id="name"
                                                label="عنوان"
                                                value={this.state.name}
                                                onChange={this.handleChange('name')}
                                                margin="normal"
                                                fullWidth
                                            />
                                            {this.validator.message('عنوان دسته بندی', this.state.name, 'required')}
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <div className="row">
                                                <div className="col-lg-7">
                                                    <h2 className="col-lg-6 col-md-6 col-sm-12"
                                                        style={headTitles}>
                                                        بارگزاری
                                                        تصویر
                                                        دسته بندی
                                                    </h2>
                                                    <Dropzone props={this}/>
                                                    <TextField
                                                        id="multiline-flexible"
                                                        label="توضیحات"
                                                        multiline
                                                        rowsMax="4"
                                                        rows="3"
                                                        value={this.state.description}
                                                        onChange={this.handleChange('description')}
                                                        margin="normal"
                                                        fullWidth
                                                    />
                                                    {this.validator.message('توضیحات', this.state.description, 'required')}
                                                </div>
                                                <div className="col-lg-2">
                                                    {
                                                        image && <ImageThumbs props={this}/>
                                                    }
                                                </div>
                                                <div className="col-lg-3">
                                                    <SketchPicker color={this.state.color}
                                                                  onChangeComplete={(val) => this.setState({color: val.hex})}/>
                                                    {this.validator.message('رنگ', this.state.color, 'required')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                        </div>

                                        <div className="col-lg-12 col-md-12 col-12">
                                            <h2 className="col-lg-3 col-md-3 col-12" style={headTitles}>آیتم های
                                                پویا</h2>
                                        </div>
                                        <DataTable columnData={propertiesHeadTable} data={properties}
                                                   addFunc={this.AddOrEditPropertiesBtn.bind(this, "Add")}
                                                   editFunc={this.AddOrEditPropertiesBtn.bind(this, "Edit")}
                                                   deleteFunc={this.deleteProperty.bind(this)}/>
                                        <div id="editPropertiesContainer" ref={this.editPropertiesContainer}
                                             style={{paddingTop: 5, margin: 'auto'}}>
                                            {this.state.showEditPropertiesContainer && (
                                                <section>
                                                    <Card className={`shadow border-0`} style={{marginTop: 25}}>
                                                        <CardHeader
                                                            className="bg-primary text-white">{this.state.txtPropertiesFunctionType}</CardHeader>
                                                        <CardBody>
                                                            <form className="row" noValidate autoComplete="off">
                                                                <div className="col-lg-5 col-md-5 col-12">
                                                                    <TextField
                                                                        id="propertiesName"
                                                                        label="عنوان"
                                                                        value={this.state.propertyName}
                                                                        onChange={this.handleChange('propertyName')}
                                                                        margin="normal"
                                                                        fullWidth
                                                                    />
                                                                    {this.validator.message('عنوان آیتم', this.state.propertyName, 'required')}
                                                                </div>
                                                                <div className="col-lg-7 col-md-7 col-12">
                                                                    <TextField
                                                                        id="propertiesName"
                                                                        label="توضیحات"
                                                                        value={this.state.propertyDesc}
                                                                        onChange={this.handleChange('propertyDesc')}
                                                                        margin="normal"
                                                                        fullWidth
                                                                    />
                                                                    {this.validator.message('توضیحات آیتم', this.state.propertyDesc, 'required')}
                                                                </div>
                                                            </form>
                                                        </CardBody>
                                                        <CardFooter>
                                                            <div style={{textAlign: 'left'}}>
                                                                <Button variant="raised"
                                                                        className="jr-btn bg-success jr-btn-sm text-white"
                                                                        style={{marginLeft: 10}}
                                                                        onClick={this.submitPropertiesBtn}>
                                                                    <i className="zmdi zmdi-check zmdi-hc-fw"/>
                                                                    <span>ثبت</span>
                                                                </Button>
                                                                <Button variant="raised"
                                                                        className="jr-btn bg-red jr-btn-sm text-white"
                                                                        style={{marginLeft: 10}}
                                                                        onClick={this.closePropertiesEditContainer}>
                                                                    <i className="zmdi zmdi-close zmdi-hc-fw"/>
                                                                    <span>انصراف</span>
                                                                </Button>
                                                            </div>
                                                        </CardFooter>
                                                    </Card>
                                                </section>
                                            )}
                                        </div>
                                    </form>
                                </CardBody>
                                <CardFooter>
                                    <div style={{textAlign: 'left'}}>
                                        <Button variant="raised" className="jr-btn bg-success jr-btn-sm text-white"
                                                style={{marginLeft: 10}} onClick={this.submitBtn}>
                                            <i className="zmdi zmdi-check zmdi-hc-fw"/>
                                            <span>ثبت</span>
                                        </Button>
                                        <Button variant="raised" className="jr-btn bg-red jr-btn-sm text-white"
                                                style={{marginLeft: 10}} onClick={this.closeEditContainer}>
                                            <i className="zmdi zmdi-close zmdi-hc-fw"/>
                                            <span>انصراف</span>
                                        </Button>
                                    </div>
                                </CardFooter>
                            </Card>
                        </section>
                    )}
                </div>

                <Dialog open={this.state.showPermenantDialog} onClose={this.handleCloseDeleteModal.bind(this)}>
                    <DialogTitle>تایید</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {this.state.permenantDialogContent}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseDeleteModal.bind(this)} color="secondary">
                            لغو
                        </Button>
                        <Button onClick={this.handleDeleteBtn.bind(this)} color="primary">
                            تایید
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        );

    }
}

export default Categories;



// WEBPACK FOOTER //
// ./app/routes/toliton/categories/categories.js